var _g, _g2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 177,
    height: 160,
    viewBox: "0 0 177 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9547 66.8696C31.6664 67.1534 32.4917 67.1534 33.2034 66.813L55.4333 56.7411C56.8564 56.0602 57.4541 54.3579 56.771 52.9394C56.1164 51.5776 54.494 50.9533 53.0992 51.5776L37.5297 58.642C44.9586 36.484 65.6515 21.6742 89.4752 21.6742C114.438 21.6742 136.269 38.2998 142.559 62.1033C142.957 63.6068 144.523 64.5149 146.031 64.1175C147.54 63.7204 148.451 62.1599 148.052 60.6563C141.107 34.3846 117.027 16 89.475 16C63.2035 16 40.3473 32.3419 32.0931 56.798L25.5466 40.4846C25.0628 39.0092 23.4404 38.1865 21.9603 38.6687C20.4801 39.151 19.6547 40.7681 20.1385 42.2435C20.1671 42.3571 20.2239 42.4704 20.2808 42.584L29.3606 65.2809C29.6453 65.9903 30.2145 66.5861 30.9547 66.8696Z",
    fill: "#76D0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3252 65.9408L31.3252 65.9407L31.3124 65.9358C30.8494 65.7584 30.4768 65.3771 30.2887 64.9085C30.2887 64.9085 30.2887 64.9085 30.2887 64.9084L21.2092 42.2126L21.1937 42.1738L21.175 42.1365C21.1443 42.0751 21.1277 42.0414 21.1148 42.012C21.1102 42.0015 21.1076 41.9949 21.1063 41.9916L21.0997 41.9655L21.0887 41.932C20.7784 40.9856 21.3121 39.9316 22.27 39.6196C23.2269 39.3078 24.2848 39.846 24.5964 40.7962L24.6065 40.827L24.6186 40.857L31.165 57.1704L32.1741 59.685L33.0406 57.1178C41.1556 33.0741 63.6262 17 89.475 17C116.581 17 140.258 35.0864 147.086 60.9119L147.086 60.9126C147.342 61.8792 146.753 62.8935 145.777 63.1505L145.777 63.1505C144.799 63.4081 143.782 62.8147 143.526 61.8471C137.117 37.5966 114.882 20.6742 89.4752 20.6742C65.2289 20.6742 44.1494 35.7518 36.5816 58.3242L35.8516 60.5016L37.9429 59.5527L53.5077 52.4903C53.5085 52.49 53.5093 52.4897 53.5101 52.4893C54.3965 52.0941 55.4437 52.4864 55.8697 53.3726L55.87 53.3733C56.3115 54.29 55.9285 55.39 55.0101 55.835L32.7907 65.9021L32.7813 65.9064L32.7719 65.9109C32.3314 66.1216 31.798 66.1293 31.3252 65.9408Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.563 108.746C156.535 108.689 156.506 108.632 156.506 108.576L147.426 85.8787C147.142 85.1693 146.573 84.5735 145.833 84.29C145.121 84.0062 144.296 84.0346 143.584 84.3466L121.354 94.4185C119.902 95.0143 119.219 96.6881 119.817 98.1351C120.415 99.582 122.094 100.263 123.546 99.6671C123.602 99.6387 123.66 99.6105 123.716 99.582L139.286 92.5176C131.8 114.676 111.079 129.485 87.2836 129.485C62.3212 129.485 40.49 112.86 34.1997 89.0564C33.8013 87.5528 32.2358 86.6447 30.7273 87.0421C29.2188 87.4392 28.3078 88.9997 28.7065 90.5033C35.6231 116.803 59.7315 135.16 87.2838 135.16C113.555 135.16 136.383 118.818 144.666 94.3616L151.212 110.675C151.753 112.15 153.375 112.916 154.855 112.377C156.335 111.838 157.104 110.221 156.563 108.746Z",
    fill: "#76D0D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.462 85.2189L145.462 85.2189L145.475 85.2238C145.938 85.4011 146.31 85.7825 146.498 86.2512L155.54 108.852C155.57 108.981 155.614 109.084 155.643 109.143C155.953 110.075 155.465 111.091 154.513 111.438L154.513 111.438C153.557 111.786 152.504 111.294 152.151 110.331L152.146 110.317L152.14 110.303L145.594 93.9892L144.586 91.4787L143.719 94.0408C135.575 118.086 113.132 134.16 87.2838 134.16C60.1763 134.16 36.4722 116.101 29.6736 90.249L29.6731 90.247C29.4168 89.2804 30.0057 88.2661 30.9819 88.0091L30.982 88.0091C31.9597 87.7516 32.9767 88.3449 33.2331 89.3125C39.6418 113.563 61.8766 130.485 87.2836 130.485C111.501 130.485 132.608 115.408 140.233 92.8376L140.971 90.655L138.873 91.6069L123.303 98.6714L123.286 98.6793L123.269 98.6878L123.186 98.7292L123.136 98.7541C122.19 99.1234 121.12 98.6697 120.741 97.7533L119.817 98.1351L120.741 97.7533C120.352 96.8105 120.801 95.7265 121.734 95.3436L121.75 95.3368L121.767 95.3294L143.985 85.2625C143.987 85.2618 143.989 85.261 143.99 85.2603C144.47 85.0515 145.015 85.0406 145.462 85.2189Z",
    stroke: "white",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.25 73.238L82.0016 95.3867L115.25 55.3867",
    stroke: "white",
    strokeWidth: 7
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_3_804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.25 73.238L82.0016 95.3867L115.25 55.3867",
    stroke: "#76D0D5",
    strokeWidth: 3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_804",
    x: 0,
    y: 0,
    width: 168.146,
    height: 91.0757,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.815686 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3_804",
    x: 8.61279,
    y: 68.0938,
    width: 168.123,
    height: 91.0659,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.815686 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3_804",
    x: 45.6378,
    y: 39.1494,
    width: 86.3037,
    height: 75.6006,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.815686 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_804",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_3_804",
    x: 41.1305,
    y: 34.4277,
    width: 95.2731,
    height: 83.2573,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.462745 0 0 0 0 0.815686 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_804"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_804",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.b2464480.svg";
export { ForwardRef as ReactComponent };